// useVideoTutorial.ts - Hook for managing video tutorial state
import { useState, useCallback } from 'react';
import type { VideoTutorialConfig } from '../components/VideoTutorial';
import { videoTutorials } from '../config/videoTutorials';

export const useVideoTutorial = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState<VideoTutorialConfig | null>(null);

  const openTutorial = useCallback((videoId: string) => {
    const video = videoTutorials.find(v => v.id === videoId);
    if (video) {
      setCurrentVideo(video);
      setIsOpen(true);
    } else {
      console.warn(`Video tutorial not found: ${videoId}`);
    }
  }, []);

  const closeTutorial = useCallback(() => {
    setIsOpen(false);
    // Keep currentVideo for a moment to allow modal close animation
    setTimeout(() => setCurrentVideo(null), 300);
  }, []);

  return {
    isOpen,
    currentVideo,
    openTutorial,
    closeTutorial,
  };
};

export default useVideoTutorial;
